import React, { useState, useEffect } from 'react';
import './Mountain.css';

const Mountain: React.FC = () => {
  const [skyColors, setSkyColors] = useState(() => {
    return getSkyColorsForTime(new Date());
  });

  useEffect(() => {
    const updateSkyColors = () => {
      setSkyColors(getSkyColorsForTime(new Date()));
    };

    updateSkyColors();
    const interval = setInterval(updateSkyColors, 60000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="mountain-container">
      <div className="sky-background"></div>
      
      <svg className="mountain-terrain" viewBox="0 0 900 400" preserveAspectRatio="xMidYMid slice">
        <defs>
          <linearGradient id="skyGradient" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" style={{ stopColor: skyColors.top, stopOpacity: 1 }} />
            <stop offset="50%" style={{ stopColor: skyColors.mid, stopOpacity: 1 }} />
            <stop offset="100%" style={{ stopColor: skyColors.bottom, stopOpacity: 1 }} />
          </linearGradient>
          
          <linearGradient id="farMountainGradient" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" style={{ stopColor: '#6B7B8C', stopOpacity: 0.6 }} />
            <stop offset="100%" style={{ stopColor: '#5A6B7D', stopOpacity: 0.8 }} />
          </linearGradient>
          
          <linearGradient id="midMountainGradient" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" style={{ stopColor: '#7A8B9C', stopOpacity: 0.7 }} />
            <stop offset="100%" style={{ stopColor: '#6B7B8C', stopOpacity: 0.9 }} />
          </linearGradient>
          
          <linearGradient id="mainMountainGradient" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" style={{ stopColor: '#8B9AAB', stopOpacity: 0.8 }} />
            <stop offset="100%" style={{ stopColor: '#6B7B8C', stopOpacity: 1 }} />
          </linearGradient>
          
          <linearGradient id="groundGradient" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" style={{ stopColor: '#9B8B75', stopOpacity: 0.9 }} />
            <stop offset="100%" style={{ stopColor: '#7B6B55', stopOpacity: 1 }} />
          </linearGradient>
        </defs>
        
        <rect width="900" height="400" fill="url(#skyGradient)" />
        
        <path
          d="M 0 400 L 0 250 Q 150 200 300 220 Q 450 200 600 210 Q 750 190 900 200 L 900 400 Z"
          fill="url(#farMountainGradient)"
        />
        
        <path
          d="M 0 400 L 0 280 Q 200 240 400 260 Q 600 230 900 250 L 900 400 Z"
          fill="url(#midMountainGradient)"
        />
        
        <path
          d="M 0 400 L 0 320 Q 100 300 200 310 Q 300 290 400 300 Q 500 280 600 290 Q 700 270 900 300 L 900 400 Z"
          fill="url(#mainMountainGradient)"
        />
        
        <path
          d="M 50 360 Q 200 310 400 260 Q 600 210 850 160 L 900 160 L 900 400 L 0 400 Z"
          fill="url(#groundGradient)"
        />
        
        <path
          d="M 0 400 L 0 380 Q 200 360 400 340 Q 600 320 850 300 L 900 300 L 900 400 Z"
          fill="url(#groundGradient)"
          opacity="0.8"
        />
      </svg>
      
      <div className="mountain-decorations">
        <div className="rock rock-1">
          <svg width="20" height="20" viewBox="0 0 20 20">
            <ellipse cx="10" cy="10" rx="8" ry="6" fill="#5A5A5A" />
            <ellipse cx="8" cy="8" rx="3" ry="2" fill="#3A3A3A" opacity="0.6" />
            <ellipse cx="12" cy="12" rx="2" ry="1.5" fill="#4A4A4A" opacity="0.5" />
          </svg>
        </div>
        <div className="rock rock-2">
          <svg width="18" height="18" viewBox="0 0 18 18">
            <ellipse cx="9" cy="9" rx="7" ry="5" fill="#5A5A5A" />
            <ellipse cx="7" cy="7" rx="2.5" ry="1.5" fill="#3A3A3A" opacity="0.6" />
          </svg>
        </div>
        <div className="rock rock-3">
          <svg width="22" height="22" viewBox="0 0 22 22">
            <ellipse cx="11" cy="11" rx="9" ry="7" fill="#5A5A5A" />
            <ellipse cx="9" cy="9" rx="3.5" ry="2.5" fill="#3A3A3A" opacity="0.6" />
            <ellipse cx="13" cy="13" rx="2.5" ry="2" fill="#4A4A4A" opacity="0.5" />
          </svg>
        </div>
        <div className="rock rock-4">
          <svg width="19" height="19" viewBox="0 0 19 19">
            <ellipse cx="9.5" cy="9.5" rx="8" ry="6" fill="#5A5A5A" />
            <ellipse cx="7.5" cy="7.5" rx="3" ry="2" fill="#3A3A3A" opacity="0.6" />
          </svg>
        </div>
        <div className="rock rock-5">
          <svg width="21" height="21" viewBox="0 0 21 21">
            <ellipse cx="10.5" cy="10.5" rx="8.5" ry="6.5" fill="#5A5A5A" />
            <ellipse cx="8.5" cy="8.5" rx="3.5" ry="2.5" fill="#3A3A3A" opacity="0.6" />
            <ellipse cx="12.5" cy="12.5" rx="2.5" ry="2" fill="#4A4A4A" opacity="0.5" />
          </svg>
        </div>
      </div>
      
      <div className="clouds">
        <div className="cloud cloud-1"></div>
        <div className="cloud cloud-2"></div>
        <div className="cloud cloud-3"></div>
      </div>
    </div>
  );
};

function getSkyColorsForTime(date: Date): { top: string; mid: string; bottom: string } {
  const hour = date.getHours();
  
  if (hour >= 22 || hour < 6) {
    return {
      top: '#1a1a2e',
      mid: '#16213e',
      bottom: '#0f3460'
    };
  } else if (hour >= 6 && hour < 10) {
    return {
      top: '#ff9a56',
      mid: '#ffad56',
      bottom: '#ffc356'
    };
  } else if (hour >= 10 && hour < 18) {
    return {
      top: '#87CEEB',
      mid: '#B0E0E6',
      bottom: '#E0F6FF'
    };
  } else {
    return {
      top: '#ff6b6b',
      mid: '#ff8c8c',
      bottom: '#ffb3b3'
    };
  }
}

export default Mountain;
